<mat-form-field appearance="outline">
  <mat-label>{{label}}</mat-label>
  <mat-select [formControl]="fc" (selectionChange)="setDateRange($event.value)" placeholder="All">
    <mat-option>All</mat-option>
    <mat-option [value]="'today'">Today</mat-option>
    <mat-option [value]="'week'">Last 7 days</mat-option>
    <mat-option [value]="'month'">Last 30 days</mat-option>
    <mat-option [value]="'custom'">Custom</mat-option>
  </mat-select>
</mat-form-field>